import { render, staticRenderFns } from "./ModerationAds.vue?vue&type=template&id=6266d0e6&scoped=true&"
import script from "./ModerationAds.vue?vue&type=script&lang=js&"
export * from "./ModerationAds.vue?vue&type=script&lang=js&"
import style0 from "./ModerationAds.vue?vue&type=style&index=0&id=6266d0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266d0e6",
  null
  
)

export default component.exports